import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { closeReviewPublishShiftDialog,openReviewPublishShiftDialog, resetBroadcastMessageState } from "../store/scheduler-slice";
import useSelectorData from "./use-scheduler-data";

const useScheduleHeader = () => {
	const dispatch = useDispatch();
	const {
		publishDraftShiftsAsyncStatus,
		hasPublishDirectAssignmentFailures,
		broadcastMessageStatus,
		isEditShiftDialogOpen,
		isReviewPublishingShiftsDialogOpen,
	} = useSelectorData();

	// const [
	// 	isReviewPublishingShiftsDialogOpen,
	// 	setIsReviewPublishingShiftsDialogOpen,
	// ] = useState(false);
	const [isBMessageDialogOpen, setIsBMessageDialogOpen] = useState(false);

	// Unassigned Workers keep the dialog open on its results screen; its Done
	// button closes it
	useEffect(() => {
		if (
			publishDraftShiftsAsyncStatus === "fulfilled" &&
			!hasPublishDirectAssignmentFailures
		)
			dispatch(closeReviewPublishShiftDialog());
	}, [
		dispatch,
		publishDraftShiftsAsyncStatus,
		hasPublishDirectAssignmentFailures,
	]);

	useEffect(() => {
		if (broadcastMessageStatus === "fulfilled") {
			setIsBMessageDialogOpen(false);
		}
	}, [broadcastMessageStatus]);

	const openBMessageDialog = () => {
		setIsBMessageDialogOpen(true);
		dispatch(resetBroadcastMessageState());
	};

	const closeBMessageDialog = () => {
		setIsBMessageDialogOpen(false);
	};

	return [
		{
			isReviewPublishingShiftsDialogOpen,
			isBMessageDialogOpen,
			isEditShiftDialogOpen,
		},
		{
			openReviewPublishShiftDialog,
			closeReviewPublishShiftDialog,
			closeBMessageDialog,
			openBMessageDialog,
		},
	];
};

export default useScheduleHeader;
